class CustomFile {
    constructor() {
        this.init();
    }

    init() {
        if (document.querySelector(".js-custom-file")) {
            let queue = {};
            const wraps = document.querySelectorAll(".js-custom-file");
            wraps.forEach(function (wrap) {
                const input = wrap.querySelector(".js-custom-file__input");
                input.addEventListener("change", function () {
                    queue[wrap.name] = wrap;
                    wrap.classList.add("loaded");
                    const files = input.files;
                    let loadedWrap = wrap

                    let inputWithDeletedFilesArray = wrap.querySelector("input[type='hidden'].removedPhotos");

                    let deletedFilesArray = JSON.parse(inputWithDeletedFilesArray?.value ? inputWithDeletedFilesArray?.value : "[]");

                    for (let i = 0; i < input.files.length; i++) {
                        let name = files[i].name;
                        let src = window.URL.createObjectURL(files[i]);
                        let item = document.createElement("div");
                        item.classList.add("custom-file__item");

                        if (Array.isArray(deletedFilesArray) && ~deletedFilesArray.indexOf(name)){
                            deletedFilesArray.splice(deletedFilesArray.indexOf(name), 1);
                            inputWithDeletedFilesArray.value = JSON.stringify(deletedFilesArray);
                        }

                        let templateItem = wrap.querySelector(".custom-file__item");
                        item.innerHTML = templateItem.innerHTML;

                        item.setAttribute("id", name);
                        item.querySelector("span").innerHTML = name;
                        loadedWrap.prepend(item);

                        let delBtn = item.querySelector('.custom-file__del')

                        delBtn.addEventListener('click',delFile)
                    }
                });
            });


            function delFile() {

                const item = this.closest('.custom-file__item'),
                    id = item.getAttribute('id'),
                    parentDiv = this.closest(".custom-file"),
                    inputFileID = parentDiv.querySelector("input[type=file]").getAttribute("id"),
                    inputFile = parentDiv.querySelector("input[type=file]");

                let targetInput = parentDiv.querySelector(".removedPhotos");

                if (!targetInput) {
                    let removeItem = document.createElement("div");
                    removeItem.innerHTML = `<input type='hidden' name='removed-files-${inputFileID}' value='[]' class='removedPhotos'>`
                    parentDiv.append(removeItem.children[0]);
                    targetInput = parentDiv.querySelector(".removedPhotos");
                }
                let removedPhotosArray = JSON.parse(targetInput.value ? targetInput.value : '[]');

                delete queue[id];

                removedPhotosArray.push(item.getAttribute("id"));

                targetInput.value = JSON.stringify(removedPhotosArray);

                if(item.parentElement.children.length < 3) {
                    inputFile.value = ''
                }

                item.remove();

            }

        }
    }
}

export default CustomFile;